<div class="mat-elevation-z3 grid-column" [class.grid-column-lesser-padding]="removePadding" [class.initial-height]="initialHeight">
    <div class="title" [class.remove-margin]="removeMargin && showHR" [class.remove-big-margin]="removeMargin && !showHR">{{title}}</div>
    <hr *ngIf="showHR" />
    <dx-button class="add-button" icon="add" [text]="languageService.LNG('Label.Add')" [visible]="hasAddButton" [disabled]="addButtonDisabled" (onClick)="onAddClicked()"></dx-button>
    <dx-button id="editButton" class="add-button" icon="edit" [visible]="hasEditButton" [disabled]="editButtonDisabled" (onClick)="onEditClicked()"></dx-button>
    <div *ngIf="hasAddButton" style="margin-top: 1em;"></div>
    <div class="margin-top-medium"></div>
    <ng-content></ng-content>
    <dx-button class="show-button" [text]="languageService.LNG('Label.Show')" [visible]="hasShowButton" (onClick)="onShowClicked()"></dx-button>
</div>
